export default __webpack_public_path__ + "static/media/pic2.e781e30b.jpg";